import React, { useEffect, useMemo, useState,useRef } from "react";
import PageLoader from "../../../Components/Loader/PageLoader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
   Select,
  MenuItem, 
  Chip
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetAllInquiryQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery,
} from "../../../Api/attoDeskApi";
import {
  ICompanyDetails,
  IInquiry,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate,Link } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { WorkOrderStatus, InquiryStatus } from "../../../Core/Enum/enum";
import DescriptionIcon from '@mui/icons-material/Description';
import dayjs from "dayjs";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import LinkIcon from '@mui/icons-material/Link';
import * as XLSX from "xlsx";
import DownloadIcon from '@mui/icons-material/Download';

const getInquiryStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case InquiryStatus.New:
      return "New";
    case InquiryStatus.Contacted:
      return "Contacted";
    case InquiryStatus.FollowUp:
      return "Follow-up Required";
    case InquiryStatus.Converted:
      return "Converted";
    case InquiryStatus.Closed:
      return "Closed";
    default:
      return "Unknown Status";
  }
};

const getInquiryStatusColor = (status: number): "default" | "primary" | "success" | "warning" | "error" => {
  switch (status) {
    case InquiryStatus.New:
      return "success"; // green
    case InquiryStatus.Contacted:
      return "primary"; // blue
    case InquiryStatus.FollowUp:
      return "warning"; // yellow
    case InquiryStatus.Converted:
      return "default"; // grey
    case InquiryStatus.Closed:
      return "error"; // red
    default:
      return "default";
  }
};




const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedCoursing, setSelectedCoursing] = useState<IInquiry | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IInquiry | null>(
    null
  );
     const [selectedCompany, setSelectedCompany] = useState<string>("");
    const capitalize = (str?: string | null) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

    const [dateFilter, setDateFilter] = useState<string>("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const componentRef = useRef<HTMLDivElement>(null);
    const [selectedStatus, setSelectedStatus] = useState<string>("");

  const { data, isLoading, isError, refetch } = useGetAllInquiryQuery({
    searchText: currentSearchQuery,
    id: "",
    customerId: "",
  });



  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

     useEffect(() => {
    if (dateFilter !== "custom") {
      let start = "";
      let end = "";
      const now = dayjs().tz("America/Toronto");
      //const now = dayjs().tz("Etc/GMT+12");
  
      switch (dateFilter) {
        case "today":
          start = end = now.format("YYYY-MM-DD");
          break;
        case "yesterday":
          start = end = now.subtract(1, "day").format("YYYY-MM-DD");
          break;
        case "this_week":
          start = now.startOf("week").format("YYYY-MM-DD");
          end = now.endOf("week").format("YYYY-MM-DD"); //  Include full week
          break;
        case "last_week":
          start = now.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
          end = now.subtract(1, "week").endOf("week").format("YYYY-MM-DD");
          break;
        case "this_month":
          start = now.startOf("month").format("YYYY-MM-DD");
          end = now.endOf("month").format("YYYY-MM-DD"); //  Ensure full month is covered
          break;
        case "last_month":
          start = now.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
          end = now.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
          break;
        default:
          break;
      }
  
      setStartDate(start);
      setEndDate(end);
    }
  }, [dateFilter]);
      

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IInquiry) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
   
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IInquiry) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading) return <PageLoader height="10vh" />;

  const coursings: IInquiry[] = Array.isArray(data?.data)
    ? (data?.data as IInquiry[])
    : [];

     const filteredCoursings = coursings.filter((row) => {
   
    
      const matchesDate =
    !dateFilter ||
    (() => {
      if (!row.created_at) return false;

      const createdDate = new Date(row.created_at).toLocaleDateString("en-CA");
      const startDateString = new Date(startDate).toLocaleDateString("en-CA");
      const endDateString = new Date(endDate).toLocaleDateString("en-CA");

      return createdDate >= startDateString && createdDate <= endDateString;
    })();

      const matchStatus = selectedStatus ? Number(row.status) === Number(selectedStatus) : true;
      
    
      return  matchesDate && matchStatus;
    });

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/quote/create");
  };

const handleExportToExcel = () => {
  if (!filteredCoursings.length) return;

  const exportData = filteredCoursings
    .map((row, index) => {
      
      return {
        "#": index + 1,
      "Customer Name": row.customer
        ? `${capitalize(row.customer.customerFirstName || "")} ${capitalize(
            row.customer.customerLastName || ""
          )}`
        : "Guest",
      "Phone": row.customer?.customerMobileNum || "",
      "Email": row.customer?.customerEmail || "",
      "Event Type": row.event_type || "",
      "Event Date": row.event_date || "",
      "Estimated Guests": row.estimated_guests || "",
      "Budget per Person": row.budget_per_person || "",
      "Status": getInquiryStatusLabel(row.status ?? InquiryStatus.New),
      "Message / Notes": row.message || "",
      "Created At": row.created_at ? new Date(row.created_at).toLocaleString() : "",
      };
    });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Inquiries");
  XLSX.writeFile(workbook, "inquiries.xlsx");
};
  

  return (

    <>
<div>
   <Grid container spacing={1} sx={{ marginTop: 1 }}>
     <Grid item xs={12}>
       <Card className={classes.card}>
         <Box mb={2} padding={2}>
           <Grid container spacing={2}>
        
             {/* <Grid item lg={2} md={2} sm={6} xs={12}>
             
             </Grid> */}
       
 
             {/* Select Date */}
             <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Date
               </Typography>
               <Select
                 className={classes.textField}
                 value={dateFilter}
                 onChange={(e) => setDateFilter(e.target.value)}
                 displayEmpty
                
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">Select date filter</MenuItem>
                 <MenuItem value="today">Today</MenuItem>
                 <MenuItem value="yesterday">Yesterday</MenuItem>
                 <MenuItem value="this_week">This Week</MenuItem>
                 <MenuItem value="last_week">Last Week</MenuItem>
                 <MenuItem value="this_month">This Month</MenuItem>
                 <MenuItem value="last_month">Last Month</MenuItem>
                 <MenuItem value="custom">Custom</MenuItem>
               </Select>
             </Grid>
 
             {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
             {dateFilter === "custom" && (
               <>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     Start Date
                   </Typography>
                   <TextField
                   variant="outlined"
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={startDate}
                     onChange={(e) => setStartDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
                     
                   />
                 </Grid>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     End Date
                   </Typography>
                   <TextField
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={endDate}
                     onChange={(e) => setEndDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
              
                   />
                 </Grid>
               </>
             )}

             <Grid item lg={2} md={2} sm={6} xs={12}>
                         <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                           Status
                         </Typography>
                                         <Select
                                         // label="Status"
                                         className={classes.textField}
                                         value={selectedStatus || ""}
                                         onChange={(event) => setSelectedStatus(event.target.value)}
                                         displayEmpty
                                         sx={{
                                           height: "37px",
                                           fontSize: "14px",
                                           padding: "4px",
                                           minWidth: "120px"
                                         }}
                                       >
                                      <MenuItem value="">All Status</MenuItem>
                                     
                                       {InquiryStatus && Object.keys(InquiryStatus).length > 0 ? (
                                         Object.entries(InquiryStatus).map(([key, value], index) => (
                                           <MenuItem key={index} value={String(value)}>
                                             {key}
                                           </MenuItem>
                                         ))
                                       ) : (
                                         <MenuItem disabled>No data available</MenuItem>
                                       )}
                                           
                                      
                                       </Select>
              </Grid>
             
           </Grid>
         </Box>
       </Card>
     </Grid>
   </Grid>
 </div>

<div ref={componentRef} >
   <Grid container spacing={1}  sx={{ marginTop: 1 }}>
      <Grid item xs={12} sm={12} md={12}>
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Inquiries</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Customer Name & Phone .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>
            {/* <Grid item sx={{ '@media print': {
                      display: 'none',
                    } }}>
                                        <Button
                                          variant="contained"
                                          className={classes.addButton}
                                          onClick={() =>
                                            navigate(`/invoice/create`)
                                          }
                                        >
                                          Add Invoice
                                        </Button>
                                      </Grid> */}
{filteredCoursings.length > 0 && (
  <><Grid item sx={{
                    '@media print': {
                      display: 'none',
                    }
                  }}>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButton}
                        >
                          Print
                        </Button>
                      )}
                      content={() => componentRef.current} />
                  </Grid><Grid item sx={{
                    '@media print': {
                      display: 'none',
                    }
                  }}>
                      <Button
                        variant="contained"
                        startIcon={<DownloadIcon />} // You can use any icon you like
                        className={classes.addButton}
                        onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid></>

)}


            
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table sx={{
    width: "100%",
    marginBottom: "1.5rem",
    verticalAlign: "top",
    "& > :not(caption) > * > *": {
      padding: "10px", // Ensure custom padding is applied
    },
  }}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Create Date</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Customer</strong>
                </TableCell>
                   <TableCell className={classes.tablheader}>
                  <strong>Phone</strong>
                </TableCell>
                {/* <TableCell className={classes.tablheader}>
                  <strong>Mode</strong>
                </TableCell> */}
                     <TableCell className={classes.tablheader}>
                  <strong>Event Type</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell>
           
                <TableCell className={classes.tablheader}>
                  <strong>Event Date</strong>
                </TableCell>

                <TableCell className={classes.tablheader}>
                  <strong>Mode</strong>
                </TableCell>
                
              
                <TableCell
                  className={classes.tablheader}
                   sx={{ textAlign: "right" ,'@media print': {
                      display: 'none',
                    } }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || filteredCoursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                filteredCoursings
                  // .filter((row: IInvoice) => row.Mode !== 'POS')
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IInquiry, index) => {
                   
                  
                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell>
                
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                         <TableCell component="th" scope="row" className={classes.tablCell}>
                       {row?.ctime
    ? dayjs(row.ctime).format("DD-MMM-YY, hh:mm A")
    : row?.created_at
    ? dayjs(row.created_at).format("DD-MMM-YY, hh:mm A")
    : "-"}
                         </TableCell>
                        <TableCell
  component="th"
  scope="row"
  className={classes.tablCell}
  sx={{ whiteSpace: "nowrap", cursor: "pointer" }} // Prevents line break & makes it clickable
  //onClick={() => navigate(`/work-order/history/${row.work_order_id}`)} // Use backticks
>
 {row.customer
                  ? `${row.customer.customerFirstName} ${row.customer.customerLastName}`
                  : "—"}
</TableCell>

<TableCell scope="row" className={classes.tablCell}>
         {row.customer?.customerMobileNum ?? "—"}
                        </TableCell>
                          <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                           {row.event_type ?? "—"}
                        </TableCell>

                        <TableCell scope="row" className={classes.tablCell}>
                            <Chip
  label={getInquiryStatusLabel(row.status ?? InquiryStatus.New)}
  color={getInquiryStatusColor(row.status ?? InquiryStatus.New)}
  size="small"
  sx={
    row.status === InquiryStatus.New
      ? {
          backgroundColor: "#7ce2a2",
          color: "#000",
        }
      : {}
  }
/>
                                             </TableCell>
                      
                        <TableCell  component="th" scope="row"  className={classes.tablCell}>
                         
                    {row?.event_date ? dayjs(row.event_date).format("DD-MMM-YY")
                                                                : "-"}
                        </TableCell>
                       
                         <TableCell  component="th" scope="row"  className={classes.tablCell}>
                         
                 {row?.mode
    ? row.mode.charAt(0).toUpperCase() + row.mode.slice(1)
    : "-"}
                       
                        </TableCell>

                        
                        
                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >

                        
                           {/* <Grid item  sx={{ '@media print': {
                      display: 'none',
                    } }}>
                              <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/invoice/history/${row.id}`)
                                }
                              >
                                <DescriptionIcon 
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid> */}

                              <Grid item sx={{ '@media print': {
                    display: 'none',
                  } }}>
                        <Button
                                                  component={Link}
                                                  variant="contained"
                                                  className={classes.viewButtonList}
                                                    to={`/customer-history/inquiry/${row.id}`}
                                                 
                                                >
                                                  <VisibilitySharpIcon
                                                    className={classes.viewListIcon}
                                                  />
                                                </Button>
                            
                            </Grid>

                           

                          {/* <Grid item sx={{ '@media print': {
                    display: 'none',
                  } }}>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      row.project?.id
        ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${row.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid> */}

                          
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
          <Grid sx={{ '@media print': { display: 'none',  } }}
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={filteredCoursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>

        {/* {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Inquiry"
            content={`Are you sure you want to delete "${coursingToDelete.quoteWorkOrderNo}"?`}
          />
        )} */}
      </Grid>
    </Card>
    </Grid>
    </Grid>
     </div>
    </>
  );
};

export default Index;
